import { useCallback, useEffect } from "react";
import { useNavigate } from "hooks/useCustomNavigation";
import { Loader } from "components/UI/atoms";
import { useAppContext } from "context/app-context";
import { setReturnToCookie } from "services/cookies";
import { INTERNAL_PATHS } from "routes/paths";

/**
 * @param privacyType Accept 'loggedIn' or 'loggedOut' values.
 */
export const PrivateGuardRouter = ({ children, privacyType = "loggedIn" }) => {
  const navigate = useNavigate();
  const { sessionInfo } = useAppContext();

  const navigateByPrivacyType = useCallback(() => {
    switch (privacyType) {
      case "loggedIn":
        if (!sessionInfo.isLoggedIn) {
          setReturnToCookie(window.location.href);
          navigate(INTERNAL_PATHS.USER_LOG_IN);
          return;
        }
        break;
      case "loggedOut":
        if (sessionInfo.isLoggedIn) {
          navigate(INTERNAL_PATHS.HOME);
          return;
        }
        break;

      default:
        break;
    }
  }, [navigate, sessionInfo.isLoggedIn, privacyType]);

  useEffect(() => {
    if (sessionInfo.isInitialLoading) return;
    navigateByPrivacyType();
  }, [sessionInfo.isInitialLoading, navigateByPrivacyType]);

  if (sessionInfo.isInitialLoading) {
    return <Loader variant="secondary" id="page-loader" />;
  }

  return children;
};
